import callApi from '../../util/apiCaller';

import { setIsFetching, FETCH_LIMIT, getItemsRequest } from '../App/AppActions';
import { addError } from '../Error/ErrorActions';

// Export Constants
export const SET_THEMES = 'SET_THEMES';

export function getThemesCountRequest(search = '', filters = null) {
    return dispatch => {
        dispatch(setIsFetching('themes/count'));
        return callApi(`themes/count?${search ? `search=${search}&` : ''}${filters ? `${Object.keys(filters).map(filterKey => `filters[${filterKey}]=${filters[filterKey]}`).join('&')}&` : ''}`).then(result => {
            return result.count;
        }).catch(err => {
            return null;
        });
    };
}

export function getThemesRequest(search = '', filters = null, sorter = null, pager = null) {
    return dispatch => dispatch(getItemsRequest('themes', null, items => dispatch(setThemes(items)), { search, filters, sorter, pager }));
}

export function editThemeRequest(theme) {
    return dispatch => {
        return callApi('theme/edit', 'post', { theme }).then(result => {
            dispatch(getThemesRequest());
            return result.theme;
        }).catch(err => {
            return null;
        });
    };
}

export function removeThemeRequest(themeId) {
    return dispatch => {
        return callApi('theme/remove', 'delete', { theme: { _id: themeId } }).then(result => {
            dispatch(getThemesRequest());
            return result.ok;
        }).catch(err => {
            return null;
        });
    };
}

// Getters
export function getThemes(store) {
    return store.themes.data;
}

export function getTheme(store, id) {
    return store.themes.data.find(theme => theme._id === id);
}

export function getAvailableLanguages() {
    return [
        // Non-EU languages
        'ar', 'bn', 'hi', 'ja', 'ru', 'zh',
        // Official languages of the European Union
        'bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'et', 'fi', 'fr', 'ga', 'hr',
        'hu', 'it', 'lt', 'lv', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'sl', 'sv',
    ].sort();
}

export function getThemesDomains(store) {
    const domains = [];
    getThemes(store).forEach(theme => {
        if(theme.domain && !domains.includes(theme.domain)) {
            domains.push(theme.domain);
        }
    });
    return domains;
}

export function getThemesMatters(store) {
    const matters = [];
    getThemes(store).forEach(theme => {
        if(theme.matter && !matters.includes(theme.matter)) {
            matters.push(theme.matter);
        }
    });
    return matters;
}

// Export Actions
export function setThemes(themes) {
    return {
        type: SET_THEMES,
        themes,
    };
}
